<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <ClientNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
            :headers="headers"
            :items="meals"
            sort-by="StartDate"
            sort-desc
            :loading="isLoading"
            loading-text="Loading Clients Meals"
            :search="search"
            height="550"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Menu</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn v-if="!isAuditorRole" color="#2b3990" dark class="mb-2" @click="showAdd()">
                  <v-icon left>add</v-icon>
                  Add Menu
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn class="primary" @click="printTable()">
                  <v-icon small> print </v-icon>
                  Print
                </v-btn>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewMeal(item)">
                mdi-eye
              </v-icon>
              <v-icon v-if="!isAuditorRole" small @click="deleteMeal(item)"> mdi-delete </v-icon>
            </template>

            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="fetch()"
                >Reset</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot class="hideOnPrint" />
    <report-table
      :reportHeaderText="reportHeaderText"
      :tableHeaders="reportTableHeader"
      :tableData="reportData"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ClientNav from "@/components/ClientNav.vue";
import ClientSide from "@/components/ClientSide.vue";
import Foot from "@/components/Footer";
import ReportTable from "@/components/Report/ReportTable.vue";

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
    ReportTable,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Start Date",
          align: "start",
          sortable: true,
          value: "StartDate",
        },
        { text: "End Date", value: "EndDate" },
        { text: "Created By", value: "CreatedBy.Name" },
        { text: "Signed By", value: "SignedBy" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      apply: false,
      msg: "",
      text: "",
      titleForm: "New Weekly Meal Plan",
      search: "",
      isLoading: true,
      meals: [],
      newStartDate: [],
      newEndDate: "",
      newCreatedBy: "",
      clientID: this.$route.params.clientID,
      userID: localStorage.getItem("userID"),
      mealID: "",
      newSignature: "",
      newProgram: "",
      staff: localStorage.getItem("Name"),
      signed: false,
      menu: false,
      menu2: false,
      clients: [],
      clientList: [],
      units: [],
    };
  },

  created() {
    this.fetch();
  },

  computed: {
    ...mapGetters({
      getClientItems: "mealPlans/getClientItems",
    }),

    reportHeaderText() {
      return "Client Meals";
    },
    reportData() {
      return this.meals;
    },
    reportTableHeader() {
      return this.headers.slice(0, this.headers.length - 1);
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  methods: {
    ...mapActions("mealPlans", ["getItemByClientId", "deleteItem"]),

    viewMeal(item) {
      this.$router.push({
        path: `/meals/${this.clientID}/update/${item._id}`,
        query: { updateMeal: true },
      });
    },

    showAdd() {
      this.$router.push({
        path: `/meals/${this.clientID}/new`,
        query: { createMeal: true },
      });
    },

    deleteMeal(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this meal plan?") &&
        this.mealDelete(id);
    },

    async mealDelete(id) {
      try {
        const response = await this.deleteItem(id);
        if (response === 400) {
          this.msg = true;
          this.text = "An Error Occured while deleting records.";
          return;
        }
        this.msg = true;
        this.text = "The meal plan has been deleted successfully.";
        this.fetch();
      } catch (error) {
        this.msg = true;
        this.text = "An Error Occured while deleting records.";
      }
    },

    async fetch() {
      this.isLoading = true;
      try {
        const response = await this.getItemByClientId(this.clientID);
        this.meals = response.data.map((item) => {
          const startDate = item.MealDateRanges?.[0] || null;
          const endDate = item.MealDateRanges?.[1] || null;
          return {
            ...item,
            StartDate: startDate,
            EndDate: endDate,
          };
        });
      } catch (error) {
        console.error("Error fetching meals:", error);
      } finally {
        this.isLoading = false;
      }
    },

    printTable() {
      document.getElementById("printTable").style.display = "block";
      window.print();
      document.getElementById("printTable").style.display = "none";
    },
  },
};
</script>

<style>
#printTable {
  display: none;
}
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
@media print {
  #printTable {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  .hideOnPrint {
    display: none;
    border: none;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
